import React, { Fragment, useEffect, useState } from "react";
import $ from "jquery";
import { axiosWithoutAuth } from "../../../axios/axiosInstance";
import LoaderButton from "../../../Layout/Common/loaderButton";
import styles from "../../CustomerFeedback/FeedbackFaces.module.css";
import "./PaymentRequired.css";
import { showErrorSnackbar } from "../../../utils/snackbarNotifications";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const SendMailModal = ({
  defaultEmail,
  transactionId,
  companyId,
  userId,
  loginName,
  phoneNumber,
  totalAmount,
}) => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isSendingMail, setIsSendingMail] = useState(false);
  const [mailSent, setMailSent] = useState(false);

  // Reset to a clean form each time the popup is opened.
  useEffect(() => {
    if (show) {
      setEmail(defaultEmail ?? "");
      setEmailError("");
      setMailSent(false);
      setIsSendingMail(false);
    }
  }, [show, defaultEmail]);

  const open = () => setShow(true);

  const close = () => {
    setMailSent(false);
    setShow(false);
  };

  // Live validation as the user types in the email field.
  const handleEmailChange = (value) => {
    setEmail(value);
    if (!value.trim()) {
      setEmailError("Email is required");
    } else if (!emailRegex.test(value.trim())) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const sendEmail = async () => {
    const emails = email.trim();

    // Validate before sending; show the error under the field and focus it.
    if (!emails) {
      setEmailError("Email is required");
      $("#emailInput").focus();
      return;
    }
    if (!emailRegex.test(emails)) {
      setEmailError("Please enter a valid email address");
      $("#emailInput").focus();
      return;
    }
    setEmailError("");

    const reqdata = {
      TransactionID: String(transactionId),
      company_Id: companyId ? String(companyId) : "0",
      userid: userId ? String(userId) : "0",
      userName: loginName ?? "",
      email: emails,
      phone: phoneNumber ?? "",
      totalAmount: String(totalAmount ?? "0"),
    };
    setIsSendingMail(true);
    try {
      const response = await axiosWithoutAuth.post("PayAccount/SendMailPayInvoice", reqdata);
      setMailSent(true);
      setTimeout(() => close(), 4000);
    } catch (error) {
      showErrorSnackbar("Unable to send email. Please try again later.");
    } finally {
      setIsSendingMail(false);
    }
  };

  return (
    <Fragment>
      <div className="button-effect">
        <button
          className="btn btn-products theme-primary"
          style={{
            backgroundColor: "#4CAF50",
            color: "white",
          }}
          onClick={open}
        >
          Email
        </button>
      </div>

      {show && (
        <Fragment>
          <div className="modal fade show pay-email-modal" style={{ display: "block" }} role="dialog" aria-modal="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                {mailSent ? (
                  <div className="modal-body">
                    <div className="pay-email-success">
                      <div className={styles.fbSuccess}>
                        <svg className={styles.checkmark} viewBox="0 0 60 60">
                          <circle cx={30} cy={30} r={30} fill="#2FAE2F" />
                          <path className={styles.tick} d="M18 31 L26 39 L42 22" />
                        </svg>
                        <p className={styles.fbSuccessText}>Email has been sent successfully.</p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <Fragment>
                    <div className="modal-header">
                      <h5 className="modal-title">Email Invoice</h5>
                      <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        disabled={isSendingMail}
                        onClick={close}
                      />
                    </div>
                    <div className="modal-body">
                      <label htmlFor="emailInput" className="form-label">
                        Email Address
                      </label>
                      <input
                        id="emailInput"
                        type="email"
                        className={`form-control ${emailError ? "is-invalid" : ""}`}
                        placeholder="Enter email address"
                        value={email}
                        disabled={isSendingMail}
                        onChange={(e) => handleEmailChange(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") sendEmail();
                        }}
                      />
                      {emailError && <div className="invalid-feedback d-block">{emailError}</div>}
                    </div>
                    <div className="modal-footer">
                      <div className="col-lg-12 acc-shipp-button">
                        <div className="popupBtns">
                          <div className="button-effect popupBtns-two">
                            <button
                              type="button"
                              className="btn btn-products btn-unavailable"
                              data-bs-dismiss="modal"
                              disabled={isSendingMail}
                              onClick={close}
                            >
                              Cancel
                            </button>
                            <LoaderButton
                              onClick={sendEmail}
                              className="btn btn-products theme-primary"
                              isLoading={isSendingMail}
                              disabled={isSendingMail || !!emailError || !email.trim()}
                              loaderText="Sending..."
                            >
                              Send Mail
                            </LoaderButton>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show pay-email-backdrop" />
        </Fragment>
      )}
    </Fragment>
  );
};

export default SendMailModal;
